import { Observable, of } from 'rxjs'
import { catchError, filter, switchMap, take, timeout } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { ConfigurationOption } from '../configuration-option'
import { configurationOptionActions } from '../configuration-option.actions'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'

@Component({
  selector: 'configuration-option-general-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionGeneralTabComponent implements OnInit {
  public configurationOption$: Observable<ConfigurationOption>
  public configurationOptionId$: Observable<string>
  public form: UntypedFormGroup

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.configurationOptionId$ = this.store
      .select(configurationOptionSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.configurationOption$ = this.configurationOptionId$.pipe(
      switchMap((configurationOptionId) =>
        this.store.select(
          configurationOptionSelectors.selectById,
          configurationOptionId
        )
      )
    )
  }

  public onSubmit(form): void {
    this.configurationOptionId$
      .pipe(take(1))
      .subscribe((configurationOptionId) =>
        this.store.dispatch(
          configurationOptionActions.updateOneById({
            id: parseInt(configurationOptionId.toString()),
            params: {
              ...form,
              id: parseInt(configurationOptionId.toString())
            }
          })
        )
      )
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
}
